import React, { useState } from 'react';
import { Card, CardBody, Col, Progress } from 'reactstrap';
import { H5, H6, LI, P, UL, Image, Btn } from '../../AbstractElements';
import folder from '../../assets/images/dashboard/folder.png';
import { SideButtons } from '../../Data/FileManager';
import { FREE, PricingPlan, Selected, TrialVersion, FileFilter, Storage,  PlanSpace } from '../../Constant';
import {  FiGrid } from 'react-icons/fi';
import { FaDatabase } from 'react-icons/fa';

const FileSideBar = () => {
  const [IsOpen, setIsOpen] = useState(false);
  const OnHandelClick = () => {
    setIsOpen(!IsOpen);
  };
  return (
    <>
      <Col xl='3' className='box-col-30 pe-0'>
        <div className='md-sidebar job-sidebar'>
          <Btn color='primary' className='md-sidebar-toggle' onClick={OnHandelClick}>
            {FileFilter}
          </Btn>
          <div className={`md-sidebar-aside custom-scrollbar ${IsOpen ? 'open' : ''}`}>
            <div className='file-sidebar'>
              <Card>
                <CardBody>
                  <UL className='simple-list'>
                    {SideButtons.map((item) => {
                      return (
                        <LI key={item.id}>
                          <div className={item.className}>
                            {item.icon}
                            {item.title}
                          </div>
                        </LI>
                      );
                    })}
                  </UL>
                  <hr style={{ opacity: 0.25 }} />
                  <UL className='simple-list '>
                    <LI>
                      <div className='btn btn-outline-primary'>
                        <FaDatabase />
                        {Storage}
                      </div>
                      <div className='m-t-15'>
                        <Progress color='primary' style={{ height: '5px' }} value={55} className='sm-progress-bar mb-1' />
                        <H6>{'25 GB of 100 GB used'}</H6>
                      </div>
                    </LI>
                  </UL>
                  <hr style={{ opacity: 0.25 }} />
                  <UL className='simple-list'>
                    <LI>
                      <div className='btn btn-outline-primary'>
                        <FiGrid />
                        {PricingPlan}
                      </div>
                    </LI>
                    <LI>
                      <div className='pricing-plan'>
                        <H6>{TrialVersion} </H6>
                        <H5>{FREE}</H5>
                        <P>{PlanSpace}</P>
                        <div className='btn btn-outline-primary btn-xs'>{Selected}</div>
                        <Image className='bg-img' src={`${folder}`} alt='' />
                      </div>
                    </LI>
                  </UL>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};
export default FileSideBar;
